import { useTranslation } from 'react-i18next'

import { PlatformUtil } from '../core'
import { useSnackbar } from '../ui-kit/snackbar'

import type { Redacted } from '@blade/std-lib'

type CopyOptions = {
  snackbarText?: string
  showSnackbar?: boolean
}

export const useClipboard = () => {
  const { showSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const copyToClipboard = async (
    text: string | Redacted.Redacted,
    options?: CopyOptions,
  ): Promise<boolean> => {
    const resolvedOptions: CopyOptions = {
      showSnackbar: true,
      snackbarText: t('common.copied'),
      ...options,
    }

    const copied = await PlatformUtil.copyToClipboard(text)

    if (resolvedOptions.showSnackbar && copied) {
      showSnackbar({
        intent: 'success',
        text: resolvedOptions.snackbarText ?? '',
        delay: 1500,
      })
    }

    return copied
  }

  return {
    copyToClipboard,
  }
}
